import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SwitchToggle from '../UI/SwitchToggle';
import Dialog from '../UI/Dialog';
import TextFields from '../UI/TextFiled';
import { Form } from 'react-form';


class Targets extends Component {

    state = {
        isDialogOpen: false
    };

    render() {
        return (
            <React.Fragment>
                <div className="page-title">
                    <div className="container">
                        <div className="row flex-center-y justify-between">
                            <div className="col-xs-9">
                                <h1 className="color-grey">Targets</h1>
                            </div>
                            <div className="col-xs-3 text-right">
                                <button onClick={() => this.setState({ isDialogOpen: true })} className="btn filled primary min-220"><i className="fa fa-plus font-sm mr-10"></i>Create a New Target</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container box py-15">
                    <div className="table mt-20">
                        <table>
                            <thead>
                                <tr>
                                    <th>Target</th>
                                    <th>Salary</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1000 deliveries</td>
                                    <td>5000 SAR</td>
                                    <td>
                                        <SwitchToggle notForm toggled={ true } field="is_active"/>
                                    </td>
                                    <td>
                                        <div className="flex-center-y justify-center">
                                            <Link to="#" className="px-10"><i className="fa fa-pencil"></i></Link>
                                            <Link to="#" className="px-10 color-red"><i className="fa fa-trash font-md"></i></Link>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>1000 deliveries</td>
                                    <td>5000 SAR</td>
                                    <td>
                                        <SwitchToggle notForm toggled={ true } field="is_active"/>
                                    </td>
                                    <td>
                                        <div className="flex-center-y justify-center">
                                            <Link to="#" className="px-10"><i className="fa fa-pencil"></i></Link>
                                            <Link to="#" className="px-10 color-red"><i className="fa fa-trash font-md"></i></Link>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>1000 deliveries</td>
                                    <td>5000 SAR</td>
                                    <td>
                                        <SwitchToggle notForm toggled={ true } field="is_active"/>
                                    </td>
                                    <td>
                                        <div className="flex-center-y justify-center">
                                            <Link to="#" className="px-10"><i className="fa fa-pencil"></i></Link>
                                            <Link to="#" className="px-10 color-red"><i className="fa fa-trash font-md"></i></Link>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <Dialog open={this.state.isDialogOpen} handleClose={ () => this.setState({ isDialogOpen: false }) }>
                    <div className="flex wrap">
                        <div className="popup-title">
                            <h2>New Target</h2>
                        </div>
                        <div className="popup-body col-xs-12">
                            <Form onSubmit={ this.submitted }>
                                { formApi => (
                                    <form onSubmit={formApi.submitForm} className="search">
                                        <TextFields type="text" label="Target" field="target"/>
                                        <TextFields type="text" label="Salary" field="salary"/>
                                    </form>
                                )}
                            </Form>
                        </div>
                        <div className="popup-meta flex justify-end col-xs-12">
                            <button className="btn filled primary min-120">Save</button>
                        </div>
                    </div>
                    <button className="no-style close-btn" onClick={ () => this.setState({ isDialogOpen: false }) }>×</button>
                </Dialog>
            </React.Fragment>
        );
    }
}

export default Targets;



// WEBPACK FOOTER //
// ./src/components/Hr/Targets.js